import Button from '@mui/material/Button';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

// import PushPinIcon from '@mui/icons-material/PushPin';
import './CodeEditorHeader.scss';

export enum ResultTabs {
	RESULT = 'result',
	JS_OUTPUT = 'jsOutput',
	JS_TESTS = 'jsTests',
}

type CodeEditorHeaderProps = {
	name: string;
	theme: string;
	defaultTab?: ResultTabs;
	isResult?: boolean;
	jsConsoleButton?: boolean;
	jsTestsButton?: boolean;
	onResultTabChange?: (tab: ResultTabs) => void;
};

const CodeEditorHeader: FC<CodeEditorHeaderProps> = ({
	name,
	theme,
	jsConsoleButton,
	jsTestsButton,
	isResult = false,
	onResultTabChange,
	defaultTab,
}) => {
	const defaultTabToSet: ResultTabs = defaultTab || ResultTabs.RESULT;
	const [activeTab, setActiveTab] = useState<ResultTabs>(defaultTabToSet);
	const { t } = useTranslation();

	const selectTab = (tab: ResultTabs) => {
		setActiveTab(tab);
		if (onResultTabChange) {
			onResultTabChange(tab);
		}
	};
	return (
		<div className={`CodeEditorHeader ${theme}`}>
			<div>
				{!isResult && (
					<div className="CodeEditorHeader__inner-container">{name}</div>
				)}

				{isResult && (
					<div className="CodeEditorHeader__result-container">
						<div
							className={`CodeEditorHeader__tab ${
								activeTab === ResultTabs.RESULT ? 'activeTab' : ''
							}`}
						>
							<Button
								size="small"
								sx={{ color: '#fff', fontWeight: '700' }}
								onClick={() => selectTab(ResultTabs.RESULT)}
							>
								{name}
							</Button>
						</div>
						{jsConsoleButton && (
							<div
								className={`CodeEditorHeader__js-output CodeEditorHeader__tab ${
									activeTab === ResultTabs.JS_OUTPUT ? 'activeTab' : ''
								}`}
							>
								<Button
									size="small"
									sx={{ color: '#fff', fontWeight: '700' }}
									onClick={() => selectTab(ResultTabs.JS_OUTPUT)}
								>
									{t('console')}
								</Button>
							</div>
						)}
						{jsTestsButton && (
							<div
								className={`CodeEditorHeader__js-output CodeEditorHeader__tab ${
									activeTab === ResultTabs.JS_TESTS ? 'activeTab' : ''
								}`}
							>
								<Button
									size="small"
									sx={{ color: '#fff', fontWeight: '700' }}
									onClick={() => selectTab(ResultTabs.JS_TESTS)}
								>
									{t('tests')}
								</Button>
							</div>
						)}
					</div>
				)}
			</div>
		</div>
	);
};

export default CodeEditorHeader;
